export const PM_DIAL = '[PM] Dial';
export const PM_INITIAL_SETUP = '[PM] Initial Setup';
export const PM_INTERACTION_STATE_CHANGE = '[PM] Interaction State Change';
export const PM_SCREEN_POP = '[PM] Screen Pop';
export const PM_CALL_LOG = '[PM] Call Log';
export const PM_USER_STATUS_CHANGE = '[PM] User Status Change';
export const PM_GET_DOSSIER_DATA = '[PM] Get Dossier Data';
export const CATEGORY_CONNECT = 'connect';
export const STATE_CONNECTED = 'CONNECTED';
export const DIRECTION_INBOUND = 'Inbound';
